import {
	getCarparkLocationsOnemap,
	getCarparkLocationsPopcar,
} from "src/services/vehicle";
import {
	drivingLicenceClassAUOptions,
	drivingLicenceClassSGOptions,
	getGoPlatformOptions,
	popcarPlatformsOptions,
} from "src/utils/options";

export const popCarConfig = {
	currencySymbol: "A$",
	carparkAddress: getCarparkLocationsPopcar,
	loginLogo: {
		img: "/assets/popcar/popcar-logo-descriptor.png",
		style: "",
	},
	sidebarLogo: {
		img: "/assets/popcar/logo.png",
		style: "border-radius: 50%",
	},
	favicon: "/assets/popcar/logo.png",
	platformOptions: popcarPlatformsOptions,
	isDamageValidationEnabled: false,
	drivingLicenceClassOptions: drivingLicenceClassAUOptions,
	timezone: "Australia/Sydney",
	defaultCountryCode: "61",
	mobileValidation: {
		pattern: /^4\d{8}$/,
		message: "Mobile number must be 9 digits and start with 4",
	},
	defaultCarParkOwner: "Intermotive Solutions Pty Ltd",
	isEVEnabled: false,
	carparkAddressPlaceholder:
		"e.g. 123 Bright Road, St Kilda, VIC 3182, Australia",
	isCarparkCoordinatesEnabled: true,
};

export const getGoConfig = {
	currencySymbol: "S$",
	carparkAddress: getCarparkLocationsOnemap,
	loginLogo: {
		img: "/assets/getgo-logo-descriptor.png",
		style: "width: 200px; height: 113px",
	},
	sidebarLogo: {
		img: "/assets/logo.png",
	},
	favicon: "/assets/logo.png",
	platformOptions: getGoPlatformOptions,
	isDamageValidationEnabled: true,
	drivingLicenceClassOptions: drivingLicenceClassSGOptions,
	timezone: "Asia/Singapore",
	defaultCountryCode: "65",
	mobileValidation: {
		pattern: /^[98]\d{7}$/,
		message: "Mobile number must be 8 digits and start with 8 or 9",
	},
	defaultCarParkOwner: "",
	isEVEnabled: true,
	carparkAddressPlaceholder: "e.g. 1 Raffles Place, Singapore 048616",
	isCarparkCoordinatesEnabled: false,
};
